import { ReservationInfoCard } from "shared/components/organisms/ReservationDetails/components/ReservationInfoCard";
import { useNextPayment, UseNextPaymentProps } from "./useNextPayment";
import { useTranslation } from "react-i18next";
import { EnumScheduledPaymentStatus } from "gql/generated";
import { formatPrice } from "shared/utils";
import { format } from "date-fns";
import { toZonedTime } from "date-fns-tz";

export const NextPayment = ({ person }: UseNextPaymentProps) => {
  const { t } = useTranslation("people", {
    keyPrefix: "PERSON_DETAILS_MODAL.STOREFRONT_INFO.NEXT_PAYMENT",
  });
  const { nextPayment } = useNextPayment({ person });

  if (!nextPayment) {
    return null;
  }

  const isFailed = nextPayment.status === EnumScheduledPaymentStatus.Failed;

  return (
    <ReservationInfoCard
      visual={isFailed ? "error" : "highlight"}
      title={t("TITLE")}
      description={
        isFailed
          ? t("FAILED", {
              orderId: nextPayment.order,
              amount: formatPrice(nextPayment.amount),
              dueDate: format(
                toZonedTime(nextPayment.dueDate, "UTC"),
                "MMMM d, yyyy",
              ),
            })
          : t("PENDING", {
              orderId: nextPayment.order,
              amount: formatPrice(nextPayment.amount),
              dueDate: format(
                toZonedTime(nextPayment.dueDate, "UTC"),
                "MMMM d, yyyy",
              ),
            })
      }
    />
  );
};
